function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulletAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.936
    },
    fill: "#FFFFFF",
    d: "M 37.5,15.5 C 39.6547,15.372 41.6547,15.872 43.5,17C 52.3333,25.8333 61.1667,34.6667 70,43.5C 71.275,51.8905 67.775,55.0571 59.5,53C 55.3333,48.8333 51.1667,44.6667 47,40.5C 46.5,179.5 46.3333,318.5 46.5,457.5C 190.5,457.667 334.5,457.5 478.5,457C 474,452.5 469.5,448 465,443.5C 463.725,435.11 467.225,431.943 475.5,434C 484,442.5 492.5,451 501,459.5C 502.422,462.03 502.755,464.697 502,467.5C 493.167,476.333 484.333,485.167 475.5,494C 467.842,496.343 464.342,493.51 465,485.5C 468.799,480.699 472.966,476.199 477.5,472C 330.086,471.997 182.753,471.33 35.5,470C 34.6667,469.167 33.8333,468.333 33,467.5C 32.6667,325.167 32.3333,182.833 32,40.5C 27.8333,44.6667 23.6667,48.8333 19.5,53C 11.225,55.0571 7.72498,51.8905 9,43.5C 18.3951,33.9371 27.8951,24.6038 37.5,15.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.919
    },
    fill: "#FFFFFF",
    d: "M 225.5,73.5 C 229.684,72.7036 232.85,74.037 235,77.5C 235.667,99.8333 235.667,122.167 235,144.5C 230.763,149.808 226.429,149.808 222,144.5C 221.333,122.167 221.333,99.8333 222,77.5C 222.69,75.6498 223.856,74.3164 225.5,73.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.977
    },
    fill: "#FFFFFF",
    d: "M 72.5,83.5 C 116.501,83.3333 160.501,83.5 204.5,84C 206.723,84.6517 207.89,86.1517 208,88.5C 208.667,103.5 208.667,118.5 208,133.5C 207.167,135.667 205.667,137.167 203.5,138C 160.5,138.667 117.5,138.667 74.5,138C 72.714,137.215 71.214,136.049 70,134.5C 69.3333,118.833 69.3333,103.167 70,87.5C 70.6622,86.0161 71.4955,84.6828 72.5,83.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.921
    },
    fill: "#FFFFFF",
    d: "M 367.5,164.5 C 370.862,164.07 373.695,165.07 376,167.5C 376.667,190.5 376.667,213.5 376,236.5C 370.865,240.957 366.532,240.29 363,234.5C 362.333,212.833 362.333,191.167 363,169.5C 364.025,167.313 365.525,165.646 367.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.982
    },
    fill: "#FFFFFF",
    d: "M 73.5,174.5 C 164.167,174.333 254.834,174.5 345.5,175C 347.286,175.785 348.786,176.951 350,178.5C 350.667,194.167 350.667,209.833 350,225.5C 349.5,227.333 348.333,228.5 346.5,229C 255.5,229.667 164.5,229.667 73.5,229C 71.6667,228.5 70.5,227.333 70,225.5C 69.3333,209.833 69.3333,194.167 70,178.5C 71.3756,177.295 72.5423,175.962 73.5,174.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.921
    },
    fill: "#FFFFFF",
    d: "M 309.5,256.5 C 312.187,256.336 314.854,256.503 317.5,257C 318.701,257.903 319.535,259.069 320,260.5C 320.667,282.833 320.667,305.167 320,327.5C 315.667,332.833 311.333,332.833 307,327.5C 306.333,305.167 306.333,282.833 307,260.5C 307.662,259.016 308.496,257.683 309.5,256.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.982
    },
    fill: "#FFFFFF",
    d: "M 72.5,266.5 C 144.834,266.333 217.167,266.5 289.5,267C 290.333,267.833 291.167,268.667 292,269.5C 292.667,285.5 292.667,301.5 292,317.5C 291.348,319.723 289.848,320.89 287.5,321C 216.5,321.667 145.5,321.667 74.5,321C 72.714,320.215 71.214,319.049 70,317.5C 69.3333,301.833 69.3333,286.167 70,270.5C 70.6622,269.016 71.4955,267.683 72.5,266.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.923
    },
    fill: "#FFFFFF",
    d: "M 396.5,347.5 C 400.355,346.845 403.188,348.179 405,351.5C 405.667,374.167 405.667,396.833 405,419.5C 399.785,424.019 395.451,423.353 392,417.5C 391.333,395.833 391.333,374.167 392,352.5C 393.025,350.313 394.525,348.646 396.5,347.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.983
    },
    fill: "#FFFFFF",
    d: "M 73.5,357.5 C 173.167,357.333 272.834,357.5 372.5,358C 373.931,358.465 375.097,359.299 376,360.5C 376.667,375.5 376.667,390.5 376,405.5C 375.5,407.333 374.333,408.5 372.5,409C 272.5,409.667 172.5,409.667 72.5,409C 70.6667,408.5 69.5,407.333 69,405.5C 68.3333,390.5 68.3333,375.5 69,360.5C 70.5,359.096 71.667,357.929 73.5,357.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletAnalysis);
export default __webpack_public_path__ + "static/media/bullet-analysis.cc47bda7ee0ce166f63abdc8ba35aa53.svg";
export { ForwardRef as ReactComponent };